// Les offres de lancement (D-186) : ce que la console de l'éditeur et la page de création de l'espace demandent à la base
// (migration 20261109000000_offres_lancement.sql). La base garde tout : la console seule écrit, une offre à la fois, la
// place prise d'un coup ; la page de vente (site/, sans l'app) lit launch_offer_public elle-même.
import { supabase } from './supabase';
import type { LaunchOffer, OfferDraft, Perk } from '../domain/offres';

const db = () => {
  if (!supabase) throw new Error('Base non configurée');
  return supabase;
};
async function must<T = unknown>(q: PromiseLike<{ data: unknown; error: { message: string; code?: string } | null }>): Promise<T> {
  const { data, error } = await q;
  if (error) throw Object.assign(new Error(error.message), { code: error.code });
  return data as T;
}
const rpc = <T>(fn: string, args: Record<string, unknown> = {}) => must<T>(db().rpc(fn, args));

export const consoleOffers = async () => (await rpc<{ today: string; offers: LaunchOffer[] } | null>('console_launch_offers')) ?? { today: new Date().toISOString().slice(0, 10), offers: [] };
export const consoleOfferSave = (d: OfferDraft) => rpc<string>('console_launch_offer_save', { p: d });
export const consoleOfferSetActive = (id: string, on: boolean) => rpc<LaunchOffer>('console_launch_offer_set_active', { p_id: id, p_on: on });

/** L'offre qu'aura le club s'il crée son espace maintenant (page /#/creer/<jeton>), ou null. */
export interface SignupOffer { title: string; perk: Perk; perk_until: string | null; perk_months: number | null; perk_percent: number | null; site_included: boolean }
export const signupOffer = (token: string) => rpc<SignupOffer | null>('signup_launch_offer', { p_token: token });
